import { useSessionExpiryWarning } from '@/hooks/use-session-expiry-warning';

export function SessionExpiryProvider({ children }: { children: React.ReactNode }) {
  useSessionExpiryWarning();
  return <>{children}</>;
}
